<template>
  <div>
    <span
      v-if="isNew"
      :class="[
        'kws-int-variety-teaser__badge',
        'badge-new--darkgreen',
        `badge-new--darkgreen-${language}`
      ]"
    ></span>
    <img :src="img.src" :srcset="img.srcset" loading="lazy" :sizes="sizes" :alt="alt" />
  </div>
</template>

<script>
export default {
  name: 'ProductImage',
  props: {
    resolutions: {
      type: Object,
      required: true,
    },
    sizes: String,
    isNew: Boolean,
    language: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    img() {
      let resolutions = [];
      Object.keys(this.resolutions)
        .forEach((resolution) => {
          const found = resolution.match(/[a-z]+-(\d+)/i);
          if (found?.length > 1) {
            resolutions.push({
              src: this.resolutions[resolution],
              w: parseInt(found[1], 10),
            });
          }
        });
      resolutions = resolutions.sort((a, b) => (a.w - b.w));
      return {
        src: resolutions[0].src,
        srcset: resolutions.map((s) => (s.src && s.w ? `${s.src} ${s.w}w` : '')).join(','),
      };
    },
  },
};
</script>

<style scoped lang="scss">
div {
  position: relative;
}
img {
  width: 100%;
}
</style>
